import * as CommonActionTypes from './actionTypes';
import extend from 'lodash/extend';

const initialState = { npn: { status: 'loading' } };
export default (state = initialState, action) => {
  switch (action.type) {
    case CommonActionTypes.BROKER_ASSOCIATIONS:
    case CommonActionTypes.SG_MIGRATION_TABLE:
    case CommonActionTypes.BROKER_ASSOCIATIONS_FAILED:
    case CommonActionTypes.SG_MIGRATION_TABLE_FAILED:
      return Object.assign({}, state, action.payload);
      break;
    case CommonActionTypes.RENEWAL_MIGRATION_CONFIG_DATA_SUCESS:
    case CommonActionTypes.RENEWAL_MIGRATION_CONFIG_DATA_FAILED:
      return { ...state, renewalMigrationConfigs: action.payload.renewalMigrationConfigs };
      break;
    case CommonActionTypes.QUOTES_SET_USER_NPN:
      const USER_NPN = Object.assign({}, action.payload);
      return extend({}, state, { npn: USER_NPN });

    default:
      return state;
  }
};
